import './polyfill';
import './header';
import './header-menu';
import {
    addDataLayer,
    EventBus,
    getScope,
    readCookie,
    reamazeClickHandler,
    setCookie,
} from '../../submodules/src/script/common';
import Vue from './vue-common';
import cr$ from '../../submodules/src/script/crquery';
import HeaderSidebar from '../../submodules/src/componentsV2/header/HeaderSidebar.vue';
import throttle from 'lodash/throttle';

window.cr$ = cr$;

cr$.ready(function () {
    // LGPD
    const POLICY_VERSION = 'v1';
    const confirmedPolicyVersion = readCookie('_upPolicy');
    const policyInfoPopUp = cr$.byId('policyInfoPopUp');

    if (policyInfoPopUp.exists() && confirmedPolicyVersion !== POLICY_VERSION) {
        policyInfoPopUp.css('display', 'block');

        cr$.byId('confirmPolicyButton').click(() => {
            policyInfoPopUp.css('display', 'none');
            let d = new Date();
            d.setTime(d.getTime() + 25 * 30 * 24 * 60 * 60 * 1000);
            setCookie('_upPolicy', POLICY_VERSION, d.toUTCString(), '/');
        });
    }

    window.dataLayer = window.dataLayer || [];

    let customerId = getScope('id');
    let hashEmail = getScope('email_hash');
    let email = getScope('email');
    let userName = getScope('user_name');
    let userAvatar = getScope('user_avatar');
    let reamazeAuthKey = getScope('reamaze_authKey');
    let isRegularCustomer = getScope('is_regular_customer');

    addDataLayer(
        customerId,
        email,
        hashEmail,
        userName,
        userAvatar,
        reamazeAuthKey,
        !isRegularCustomer ? 2 : 1
    );

    if (customerId) {
        requestIdleCallback(() => {
            cr$.byClass('logged').removeClass('hidden');
            cr$.byClass('desloged').addClass('hidden');
        });
    }

    // Reamaze click
    const reamazeElm = cr$.byId('olark-tab');
    reamazeElm.click(reamazeClickHandler);

    cr$.byId('onlineChatReamaze').click(() => reamazeElm.click());

    // Sidebar init
    requestIdleCallback(() => {
        if (cr$.byId('header-sidebar').exists()) {
            new Vue(HeaderSidebar);
        }
    });

    // Sidebar cart open
    cr$.byClass('button-open-cart').click(function (e) {
        EventBus.$emit('open-sidebar', 'cart');
    });

    // Sidebar search open
    cr$.byClass('button-open-search').click(function (e) {
        EventBus.$emit('open-sidebar', 'search');
    });

    // Siderbar login open
    cr$.byId('button-open-login').click(function (e) {
        e.stopPropagation();
        e.preventDefault();

        EventBus.$emit('open-sidebar', 'login');
    });

    // Sidebar my account open
    cr$.byId('button-open-my-account').click(function (e) {
        EventBus.$emit('open-sidebar', 'my-account');
    });

    // Bag Count Products
    EventBus.$on('cart-products-count-changed', (newCout) => {
        cr$.byClass('header-cart-counter').each((el) => {
            const element = cr$.byEl(el);
            element.html(newCout);

            if (newCout > 0) {
                element.show();
            } else {
                element.hide();
            }
        });
    });

    const logoAnimationEl = cr$.byId('logo-mobile-animation');
    if (logoAnimationEl.exists()) {
        let isShowingLogo = false;
        const offsetToChangeLogo = 50; // pixels
        window.addEventListener(
            'scroll',
            throttle(
                () => {
                    if (window.innerWidth > 768) return;

                    const scroll = document.body.scrollTop || document.documentElement.scrollTop;

                    if (scroll > offsetToChangeLogo && !isShowingLogo) {
                        //Scroll para baixo -> logo circle
                        logoAnimationEl.scrollTo(0, logoAnimationEl.raw.scrollHeight);
                        isShowingLogo = true;
                    } else if (scroll < offsetToChangeLogo && isShowingLogo) {
                        //Scroll para cima -> logo Chico Rei
                        logoAnimationEl.scrollTo(0, 0);
                        isShowingLogo = false;
                    }
                },
                500,
                {
                    leading: true,
                    trailing: true,
                }
            ),
            { passive: true }
        );
    }
});
